<mat-toolbar class="page-header-content" [ngStyle]="{ 'background-color': color }">
    <mat-icon>{{icon}}</mat-icon>
    <mat-label class="font-size-14 pl-10">{{ title }}</mat-label>
    <span fxFlex></span>
    <ng-content> </ng-content>
</mat-toolbar>